import * as React from 'react';

export interface ITextboxProps {
    id: string;
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyPress?: (e: React.FormEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.FormEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FormEvent<HTMLInputElement>) => void;
    labelText?: string;
    placeHolder?: string;
    required?: boolean;
    value: string;
    autoFocus?: boolean;
    type?: string;
    disabled?: boolean;
}

export function Textbox({
    id,
    onInput = () => { },
    onKeyPress = () => { },
    onKeyDown = () => { },
    onBlur = () => { },
    onFocus = () => { },
    labelText = '',
    placeHolder = '',
    required = false,
    value = '',
    autoFocus = false,
    type = 'text',
    disabled = false,
}: ITextboxProps) {
    const onInputHandler = (e: React.FormEvent<HTMLInputElement>) => {
        onInput(e);
    };

    const onKeyPressHandler = (e: React.FormEvent<HTMLInputElement>) => {
        onKeyPress(e);
    };

    const onKeyDownHandler = (e: React.FormEvent<HTMLInputElement>) => {
        onKeyDown(e);
    };

    const onBlurHandler = (e: React.FormEvent<HTMLInputElement>) => {
        onBlur(e);
    };

    const onFocusHandler = (e: React.FormEvent<HTMLInputElement>) => {
        onFocus(e);
    }

    return (
        <React.Fragment>
            <label htmlFor={id} className="visually-hidden">
                <span >{labelText}</span>
            </label>
            <input type={type ? type : 'text'} id={id}
                autoFocus={autoFocus}
                onChange={onInputHandler}
                onKeyDown={onKeyDownHandler}
                onBlur={onBlurHandler}
                onFocus={onFocusHandler}
                value={value}
                onKeyPress={onKeyPressHandler}
                placeholder={placeHolder}
                required={required}
                disabled={disabled}
            />
        </React.Fragment>
    );
};
